import { Booking } from '../../models/Booking'
import { User } from '../../models/User'
import { currencyFormat } from '../../utils/numbers'
import Button from '../app/design/Button'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import Tooltip from '../app/design/Tooltip'
import { Clickable } from '../common/Clickable'
import { ContactAvatar } from '../contacts/ContactAvatar'
import { ServiceAlertSubtitle } from './ServiceAlertSubtitle'

type Props = {
    booking: Booking
}

export function UnpaidBookingAlert({ booking }: Props) {
    const client = booking.client ?? new User()

    return (
        <div>
            <Clickable
                className="flex items-center justify-between rounded-lg px-4 py-2"
                href={`/bookings/${booking.id}`}
            >
                <div className="flex items-center gap-4">
                    <ContactAvatar
                        size="md"
                        user={booking.subaccount ?? client}
                        subaccountParentClientName={booking.subaccount?.client?.name}
                        showName={true}
                        truncateName={true}
                        subtitle={
                            <>
                                <ServiceAlertSubtitle
                                    services={
                                        booking.services.length ? booking.services : booking.lines
                                    }
                                />
                                <Paragraph size="sm" className="text-gray-600">
                                    {booking.date?.format('ddd, MMM Do YYYY')}
                                </Paragraph>
                            </>
                        }
                    />
                </div>

                <div className="align-right flex flex-col items-end gap-1 self-start">
                    <Label size="md" className="text-gray-700">
                        {currencyFormat(booking.amount)}
                    </Label>
                    {booking.job?.person && (
                        <Tooltip label={booking.job?.person.name ?? ''} position="left">
                            <ContactAvatar size="xs" user={booking.job?.person} />
                        </Tooltip>
                    )}
                </div>
            </Clickable>
            <div className="px-4">
                <Button
                    className="mt-2 w-full"
                    intent="secondary"
                    size="small"
                    href={`/charge/booking/${booking.id}/complete`}
                >
                    Charge
                </Button>
            </div>
        </div>
    )
}
